
import { Component, Vue } from "vue-property-decorator";
import { Store } from "vuex";
import { IUserProfileUpdate } from "@/interfaces";
import { readHasAdminAccess, readUserProfile } from "@/store/main/getters";
import { dispatchUpdateUser } from "@/store/admin/actions";
import { readAdminOneUser, readLanguage } from "@/store/admin/getters";
import { commitSwitchLanguage } from "@/store/admin/mutations";
import myUpload from 'vue-image-crop-upload/upload-2.vue';
import { readToken } from "@/store/main/getters";
import { api } from "@/api";

@Component({
  components: {
    'my-upload': myUpload
  },
})
export default class UserProfileEdit extends Vue {
  public valid = true;
  public firstname: string = "";
  public lastname: string = "";
  public email: string = "";
  public gender: string = "";
  public road: string = "";
  public house_number: string = "";
  public postcode = 0;
  public city = "";
  public birthplace: string = "";
  public birthday: Date = new Date(1900, 1, 1);
  public nationality: string = "";
  public is_superuser: boolean = false;
  public is_active: boolean = false;
  public password1: string = "";
  public password2: string = "";
  public items = ["male", "female", "divers"];
  public itemsDE = ["männlich", "weiblich", "divers"];
  public id: number = 0;
  public edit = true;//Could be used to disable the edit mode, but not implemented anymore

  public passwordEditBool = false; //Only the user himself can change his password
  public saveTheMainAdmin = false; //No one can change the mainadmins password
  public isCurrentUserMainAdmin = false; //Only the mainadmin can change the password of other users


  //For imageCropUpload----------------
  public show = false;
  public set = false;
  public imgDataUrl: string = '';
  public params = {
    token: '123456789',
    name: 'avatar'
  };
  public headers = {
    smail: '*_~'
  }

  public de = {
    hint: 'Click or drag the file here to upload',
    loading: 'Uploading…',
    noSupported: 'Dieser Browser wird nicht unterstützt, bitte benutzen sie IE10+ oder vergleichbare.',
    success: 'Hochladen erfolgreich',
    fail: 'Hochladen fehlgeschlagen',
    preview: 'Vorschau',
    btn: {
      off: 'Abbrechen',
      close: 'Schließen',
      back: 'Zurück',
      save: 'Speichern'
    },
    error: {
      onlyImg: 'Nur Bilder',
      outOfSize: 'Bild ist zu groß. Limit ist: ',
      lowestPx: 'Bilder Größe ist zu gering. Mindestgröße ist: '
    }
  }

  public en = {
    hint: 'Click or drag the file here to upload',
    loading: 'Uploading…',
    noSupported: 'Browser is not supported, please use IE10+ or other browsers',
    success: 'Upload success',
    fail: 'Upload failed',
    preview: 'Preview',
    btn: {
      off: 'Cancel',
      close: 'Close',
      back: 'Back',
      save: 'Save'
    },
    error: {
      onlyImg: 'Image only',
      outOfSize: 'Image exceeds size limit: ',
      lowestPx: 'Image\'s size is too low. Expected at least: '
    }
  }

  get adminLabel() {
    return this.$t('admin_rights');
  }

  get text() {
    if (this.language) {
      return this.en;
    } else return this.de;
  }

  public toggleShow() {
    this.show = !this.show;
  }

  cropSuccess(imgDataUrl, field) {
    this.set = true;
    console.log('-------- crop success --------');
    this.imgDataUrl = imgDataUrl;
  }

  cropUploadSuccess(jsonData, field) {
    console.log('-------- upload success --------');
    console.log(jsonData);
    console.log('field: ' + field);
  }

  cropUploadFail(status, field) {
    console.log('-------- upload fail --------');
    console.log(status);
    console.log('field: ' + field);
  }

  //Should not be used at the time -> imgDataUrl is already a b64
  public async b64Helper(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise((resolve) => {
      reader.onloadend = () => {
        resolve(reader.result);
      };
    });
  }

  private b64Cleaner(b64: string) {
    let newA: String = b64.replace(
      "dataimage/pngbase64",
      "data:image/png;base64,"
    );
    let newB: String = newA.replace(
      "dataimage/jpegbase64",
      "data:image/jpeg;base64,"
    );
    //Removing padding from backend
    let newC = newB.replace(
      "=",
      ""
    )
    return newC;
  }

  //---------------------------------------

  public async mounted() {

  }

  public async created() {
    const userProfile = readAdminOneUser(this.$store)(Number(this.$route.params.id));
    const currentProfil = readUserProfile(this.$store);
    //No is allowed to change anything about the password -> This is also made sure in the backend! here only necessary for communication with the user
    if (userProfile?.id == 1 && currentProfil?.id != 1) {
      this.saveTheMainAdmin = true;
    }
    if (!currentProfil?.is_superuser) {
      console.log("SHIT")
      this.cancel();
    }
    var responseb64: string = "";
    await api
      .getProfilePicUser(
        readToken(this.$store),
        userProfile?.id as number
      )
      .then((response) => (responseb64 = response.data))
      .catch((error) => console.log(error));
    this.imgDataUrl = this.b64Cleaner(responseb64);
    if (currentProfil?.id == 1) {
      this.isCurrentUserMainAdmin = true;
    }
    //Only the user himself should be able to change the password or the main admin
    if (userProfile?.id == currentProfil?.id || currentProfil?.id == 1) {
      this.passwordEditBool = true;
    }
    if (userProfile) {
      this.firstname = userProfile.firstname;
      this.lastname = userProfile.lastname;
      this.email = userProfile.email;
      this.birthday = userProfile.birthday;
      this.birthplace = userProfile.birthplace;
      this.gender = userProfile.gender;
      this.city = userProfile.city;
      this.road = userProfile.road;
      if (userProfile.house_number) {
        this.house_number = userProfile.house_number;
      }
      this.postcode = userProfile.postcode;
      this.nationality = userProfile.nationality;
      this.is_superuser = userProfile.is_superuser;
      this.is_active = userProfile.is_active;
    }
  }

  get userProfile() {
    return readAdminOneUser(this.$store)(Number(this.$route.params.id));
  }

  get hasAdminAccess() {
    const user = readUserProfile(this.$store);
    return user?.is_superuser;
  }

  public reset() {
    this.password1 = "";
    this.password2 = "";
    if (this.userProfile) {
      this.firstname = this.userProfile.firstname;
      this.lastname = this.userProfile.lastname;
      this.email = this.userProfile.email;
      this.birthday = this.userProfile.birthday;
      this.birthplace = this.userProfile.birthplace;
      this.gender = this.userProfile.gender;
      this.city = this.userProfile.city;
      if (this.userProfile.house_number) {
        this.house_number = this.userProfile.house_number;
      }
      this.road = this.userProfile.road;
      this.postcode = this.userProfile.postcode;
      this.is_superuser = this.userProfile.is_superuser;
      this.is_active = this.userProfile.is_active;
    }
  }

  get editField() {
    return !this.saveTheMainAdmin;
  }

  public cancel() {
    this.$router.back();
  }

  public numberRules = [
    v => (v > 1000 || v < 1000000) || 'Please enter an valid postcode'
  ];
  public numberRules_german = [
    v => (v > 1000 || v < 1000000) || 'Bitte gib eine gültige PLZ ein'
  ];

  public goToPassword() {
    this.$router.push('/main/profile/password');
  }

  public async submit() {
    if (this.saveTheMainAdmin) {

    }
    const updatedProfile: IUserProfileUpdate = {};
    if (this.userProfile?.firstname != this.firstname) {
      updatedProfile.firstname = this.firstname;
    }
    if (this.userProfile?.is_superuser != this.is_superuser) {
      updatedProfile.is_superuser = this.is_superuser;
    }
    if (this.userProfile?.is_active != this.is_active) {
      updatedProfile.is_active = this.is_active;
    }
    if (this.userProfile?.gender != this.gender) {
      updatedProfile.gender = this.gender;
    }
    if (this.userProfile?.lastname != this.lastname) {
      updatedProfile.lastname = this.lastname;
    }
    if (this.userProfile?.email != this.email) {
      updatedProfile.email = this.email;
    }
    if (this.birthday != null) {
      if (this.birthday.toString() != new Date(1900, 1, 1).toString()) {
        if (this.birthday.toString() != this.birthday.toString()) {
          updatedProfile.birthday = this.birthday;
        }
      }
    }
    if (this.userProfile?.birthplace != this.birthplace) {
      updatedProfile.birthplace = this.birthplace;
    }
    if (this.userProfile?.nationality != this.nationality) {
      updatedProfile.nationality = this.nationality;
    }
    if (this.userProfile?.road != this.road) {
      updatedProfile.road = this.road;
    }
    if (this.userProfile?.house_number != this.house_number) {
      updatedProfile.house_number = this.house_number;
    }
    if (this.userProfile?.postcode != this.postcode && this.postcode != 0) {
      updatedProfile.postcode = this.postcode;
    }
    if (this.userProfile?.city != this.city) {
      updatedProfile.city = this.city;
    }

    if (this.isCurrentUserMainAdmin) {
      if (this.password1 == this.password2 && this.password1 != "") {
        updatedProfile.password = this.password1;
      }
    }
    if (this.imgDataUrl) {
      let b64 = this.imgDataUrl;
      try {
        await dispatchUpdateUser(this.$store, {
          id: Number(this.userProfile?.id),
          user: updatedProfile,
          file: b64 as string
        });
      } catch (e) {

      }
    } else {
      await dispatchUpdateUser(this.$store, { id: Number(this.userProfile?.id), user: updatedProfile, file: "null" });
    }
    this.$router.push("/main/admin/users/all");
  }

  get language() {
    return readLanguage(this.$store);
  }

  public swtichLanguageEng() {
    console.log("Englisch");
    //True means eng
    if (this.language) {
      commitSwitchLanguage(this.$store);
    }
  }

  public beforeDestroy() {
    if (this.set) {
      this.submit();
    }
  }

  public swtichLanguageDe() {
    //False means de
    console.log("DEUTSCH");
    if (!this.language) {
      commitSwitchLanguage(this.$store);
    }
  }
}
